module.exports = "images/search.7a12605b.png";